import React from 'react';
import classNames from 'classnames'

export const Checkbox = ({ label, attribute, isChecked, onChange, className, rounded, required }) => {
    return (
        <div className={className}>
            <label className="flex items-center text-sm text-gray-500 relative pl-[28px] select-none cursor-pointer">
                <input
                    className={classNames(
                        'bg-gray-100 bg-no-repeat bg-[100% 100%] w-6 h-6 border border-gray-300 appearance-none cursor-pointer absolute top-0 left-0 ease-in duration-200 hover:bg-gray-300 checked:bg-brand-1 checked:hover:bg-brand-1 checked:border-brand-1 checked:bg-check',
                        {
                            'rounded-md': rounded,
                            'rounded-none': !rounded
                        }
                    )}
                    type="checkbox"
                    name={attribute}
                    checked={isChecked}
                    onChange={onChange}
                    required={required}
                />
                {label}{required && ' *'}
            </label>
        </div>
    );
};
